import React from "react";

function InputTendinaDatoProdotto(props) {
        
    const {
        inputLabel,
        datoName,
        datoId,
        datoOnChange,
        datoClass,
        objOpzioni,
        datoValue,
        bloccoClass,
        permessoScrittura,
        labelOrizzontale
    } = props

    

    if (permessoScrittura === "NO") {
        return(
            <p className={bloccoClass}><strong>{inputLabel}: </strong>{datoValue}</p>
        )
    } else {
        if (labelOrizzontale !== "SI") {
            return (
            <div className={bloccoClass+" mb2"}>
                <label htmlFor={datoId}>{inputLabel}</label><br />
                   <select
                        name={datoName}
                        id={datoId}
                        className={datoClass}
                        onChange={datoOnChange}
                        value={datoValue}
                    >      
                    {
                        objOpzioni.map((dato,ind) => <option key={ind} value={dato.valueId ?? dato.idPS ?? dato.valueDesc ?? ""} >{dato.desc}</option>)
                    }                          
                    </select> 
            </div>)
        } else {
            return (
                <div className={bloccoClass+" flex items-center"}>
                    <label htmlFor={datoId} className="wpx-60 pointer mr2 labInp">{inputLabel}</label>
                       <select
                            name={datoName}
                            id={datoId}
                            className={datoClass}
                            onChange={datoOnChange}
                            value={datoValue}
                        >      
                        {
                            objOpzioni.map((dato,ind) => <option key={ind} value={dato.valueId ?? dato.idPS ?? dato.valueDesc ?? ""} >{dato.desc}</option>)
                        }                          
                        </select> 
                </div>)
        }
    }

    
}

export default InputTendinaDatoProdotto;